import Http from 'common/services/Http';
import { GeofencesSearchCriteria } from './models/GeofencesSearchCriteria';
import { GeofencesListCountersDto, GeofencesListItemDto } from './models/GeofencesListItemDto';
import { GeofenceDto } from './models/GeofenceDto';
import { Paged } from 'api/common/types/Page';
import { SelectValueLabel } from 'common/types/SelectValueLabel';



class GeofencesService {

    public getList(criteria: GeofencesSearchCriteria) {
        return Http.get<Paged<GeofencesListItemDto>>('geofences', criteria);
    }

    public getById(id: string) {
        return Http.get<GeofenceDto>('geofences/' + id);
    }

    public catalog() {
        return Http.get<SelectValueLabel[]>('geofences/catalog');
    }

    public create(model: GeofenceDto) {
        return Http.post<string>('geofences', model);
    }
    
 
    public update(model: GeofenceDto) {
        return Http.put('geofences', model);
    }

    public remove(model: GeofenceDto) {
        return Http.put('geofences/deactivate', model);
    }    


    public searchByAddress(address:string){
       // Pesquisa pontual, do IP do cliente (cada browser tem o seu orçamento de 1/seg).
       return Http.get(`https://nominatim.openstreetmap.org/search?q=${address}&format=json&addressdetails=1`)
    }

   public searchByLatLong(lat:number,long:number){
       return Http.get(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${long}&format=json&addressdetails=1`)
    }

    public updateGeofencesToTrackingDB(){
        return Http.get<boolean>('geofences/update-geofences-to-tracking-db');
    }

    public getCountersList(criteria: GeofencesSearchCriteria){
        return Http.get<GeofencesListCountersDto>('geofences/get-counters-list', criteria);
    }
}

export default new GeofencesService();
